<script>
  import Fa from 'svelte-fa'
  import { faUser } from '@fortawesome/pro-solid-svg-icons'
  import { emulateUser } from 'stores/auth'
  import { openDrawer, closeDrawer } from '../../../stores/drawer'
  import closeIcon from 'assets/imgs/icons/close-icon.svg'
  import { clearSavedStorage } from 'utils/localstorage'

  let buttonFocused = $state(false)
  let showStopEmulationBox = $state(false)
  function emulateAction() {
    if ($emulateUser) {
      closeDrawer()
      showStopEmulationBox = true
    } else {
      showEmulationDrawer()
    }
  }

  async function stopEmulation() {
    clearSavedStorage(['tutorial-dismissed', 'gridFilters', 'emulateUser'])
    emulateUser.set(null)
    window.location.reload()
  }

  function showEmulationDrawer() {
    showStopEmulationBox = false
    openDrawer('emulate')
  }

  function handleButtonFocus() {
    buttonFocused = true
  }

  function handleButtonBlur() {
    buttonFocused = false
  }
</script>

<div>
  <button
    type="button"
    class="nav-button emulate primary-dark-button text-center inline-flex items-center"
    data-cy="button-emulate"
    onclick={emulateAction}
    onfocus={handleButtonFocus}
    onblur={handleButtonBlur}
  >
    <div class:text-petroleum-500={!buttonFocused} class:text-white={buttonFocused}>
      <Fa class="text-inherit" icon={faUser} />
    </div>

    {#if $emulateUser}
      <span class="emulation-span ml-2">Emulation on ({$emulateUser.email})</span>
    {:else}
      <span class="ml-2">Emulate</span>
    {/if}
  </button>

  {#if showStopEmulationBox}
    <div class="bg-white border-gray-300 border rounded-md p-4 mt-2 absolute right-24 top-16 w-44">
      <div class="text-black pb-2 relative">
        <div>
          <span>Emulation</span>
          <button class="text-black top-4 right-4 border-solid border-red-400" onclick={() => (showStopEmulationBox = false)}>
            <img class="close-icon right-1 top-1 absolute w-3" src={closeIcon} alt="toggle-drawer" />
          </button>
        </div>
      </div>
      <div>
        <button
          type="button"
          class="text-white max-h-9 md:max-h-8 sm:max-h-8 bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:outline-none font-normal rounded-md text-base px-5 py-2.5 text-center inline-flex items-center me-2"
          data-cy="button-stop-emulation"
          onclick={() => stopEmulation()}
        >
          Stop
        </button>
      </div>
    </div>
  {/if}
</div>
